module.exports = __webpack_public_path__ + "static/media/um.b2508e2a.svg";